import { Paragraph, Text } from '@zillow/constellation-10';

import { StyledList } from '../../../../StyledComponents/StyledWizardForm';

const IdVerificationContent = () => (
  <>
    <Paragraph css={{ marginBottom: '400' }}>
      To protect applicants&apos; confidential information, we&apos;ll need to verify your identity before you can view
      applications.
    </Paragraph>
    <Paragraph>Applications include each renter&apos;s:</Paragraph>
    <StyledList marginBottom="sm">
      <StyledList.Item paddingY={0}>
        <Text>Comprehensive credit report</Text>
      </StyledList.Item>
      <StyledList.Item paddingY={0}>
        <Text>Background check</Text>
      </StyledList.Item>
      <StyledList.Item paddingY={0}>
        <Text>Income documents (if provided)</Text>
      </StyledList.Item>
    </StyledList>
    <Paragraph>
      Once completed, your ID verification will be valid for <Text textStyle="body-bold">335 days.</Text>
    </Paragraph>
  </>
);

export default IdVerificationContent;
